import { useEffect, useState } from 'react';
import MainLayout from '../layouts/MainLayout';
import { getUserDetails, updatePassword } from '../api/api';
import { toast, ToastContainer } from 'react-toastify';

const ProfilePage = () => {
    const [user, setUser] = useState(null);
    const [activeTab, setActiveTab] = useState('account');

    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');

    useEffect(() => {
        const fetchUserData = async () => {
            const res = await getUserDetails();
            setUser(res);
        };
        fetchUserData();
    }, []);

    const handlePasswordChange = async () => {
        if (!currentPassword || !newPassword || !confirmPassword) {
            setMessage('All fields are required.');
            return;
        }
        if (newPassword.length < 6) {
            setMessage('Password must be at least 6 characters long.');
            return;
        }
        if (newPassword.length > 50) {
            setMessage('Password must be less than 50 characters long.');
            return;
        }
        if (newPassword !== confirmPassword) {
            setMessage('New password and confirm password do not match.');
            return;
        }
        if (newPassword === currentPassword) {
            setMessage('New password cannot be the same as the current password.');
            return;
        }

        const res = await updatePassword({ currentPassword, newPassword });
        toast.success(res.message);

        setMessage('');
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
    };

    return (
        <MainLayout>
            <div className="max-w-2xl mx-auto mt-10 bg-[#212121] text-white p-8 rounded shadow-md">
                {/* Tabs */}
                <div className="flex border-b border-gray-600 mb-6">
                    <button
                        onClick={() => setActiveTab('account')}
                        className={`px-4 py-2 ${activeTab === 'account' ? 'border-b-2 border-blue-500 text-blue-400' : 'text-gray-400'}`}
                    >
                        Account Information
                    </button>
                    <button
                        onClick={() => setActiveTab('password')}
                        className={`px-4 py-2 ${activeTab === 'password' ? 'border-b-2 border-blue-500 text-blue-400' : 'text-gray-400'}`}
                    >
                        Change Password
                    </button>
                </div>

                {/* Tab Content */}
                {activeTab === 'account' && (
                    user && <div>
                        <div className="mb-4">
                            <label className="block text-sm mb-1">Name : {user.name}</label>
                            {/* <input
                                type="text"
                                value={user.name}
                                disabled
                                className="w-full px-3 py-2 bg-black border border-gray-700 rounded text-white"
                            /> */}
                        </div>
                        <div>
                            <label className="block text-sm mb-1">Email : {user.email}</label>
                            {/* <input
                                type="email"
                                value={user.email}
                                disabled
                                className="w-full px-3 py-2 bg-black border border-gray-700 rounded text-white"
                            /> */}
                        </div>
                    </div>
                )}

                {activeTab === 'password' && (
                    <div>
                        <div className="mb-4">
                            <label className="block text-sm mb-1">Current Password</label>
                            <input
                                type="password"
                                value={currentPassword}
                                onChange={(e) => { setMessage(''); setCurrentPassword(e.target.value) }}
                                className="w-full px-3 py-2 bg-black border border-gray-700 rounded text-white"
                                placeholder="Enter current password"
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block text-sm mb-1">New Password</label>
                            <input
                                type="password"
                                value={newPassword}
                                onChange={(e) => { setMessage(''); setNewPassword(e.target.value) }}
                                className="w-full px-3 py-2 bg-black border border-gray-700 rounded text-white"
                                placeholder="Enter new password"
                            />
                        </div>
                        <div className="mb-6">
                            <label className="block text-sm mb-1">Confirm New Password</label>
                            <input
                                type="password"
                                value={confirmPassword}
                                onChange={(e) => { setMessage(''); setConfirmPassword(e.target.value) }}
                                className="w-full px-3 py-2 bg-black border border-gray-700 rounded text-white"
                                placeholder="Confirm new password"
                            />
                        </div>
                        {message && <div className="mb-4 text-sm text-red-400">{message}</div>}
                        <div className="flex justify-end">
                            <button
                                onClick={handlePasswordChange}
                                className="w-full sm:w-auto px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                            >
                                Update Password
                            </button>
                        </div>
                    </div>
                )}

                <ToastContainer position="top-right" autoClose={5000} />
            </div>
        </MainLayout>
    );
};

export default ProfilePage;
